import { CircularProgress } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dispatch, useSelector } from 'store';
import { openAlert } from 'store/slices/notification';
import { onFetchSimulations, onDeleteSimulation, onOpenDeleteAlert } from 'store/slices/simulation';
import { openSnackbar } from 'store/slices/snackbar';

import AlertDialog from 'ui-component/dialogs/AlertDialog';

const DeleteSimulationAlert: FC = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const { openDelete, simulationId } = useSelector((state) => state.simulation);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleUndo = () => {
        dispatch(onOpenDeleteAlert(!openDelete));
    };

    const handleDelete = async () => {
        if (!user || !simulationId) return false;

        setIsLoading(true);
        try {
            const res = await dispatch(onDeleteSimulation(user.userId, user.userName, simulationId));
            if (res) {
                dispatch(onOpenDeleteAlert(false));
                dispatch(openAlert(true));
                dispatch(onFetchSimulations(user.tenantId));
                dispatch(
                    openSnackbar({
                        open: true,
                        message: t('SIMULATION_DELETED_SUCCESSFULLY'),
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: false
                    })
                );
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: t('SIMULATION_DELETED_FAILED'),
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            }
            setIsLoading(false);
            return res;
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: t('SIMULATION_DELETED_FAILED'),
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            setIsLoading(false);
            return false;
        }
    };

    return (
        <AlertDialog
            open={openDelete}
            dialogTitle="Sei sicuro di voler procedere?"
            content="Attenzione! Eliminando la simulazione perderai tutte le modifiche effettuate e non si potrà più tornare indietro. Assicurati di aver valutato attentamente le conseguenze prima di procedere."
            onAccept={handleDelete}
            onCancel={handleUndo}
            onClose={handleUndo}
            acceptButtonProps={{
                children: isLoading ? (
                    <CircularProgress color="inherit" sx={{ width: '20px !important', height: '20px !important' }} />
                ) : (
                    'Elimina simulazione'
                ),
                variant: 'contained'
            }}
            cancelButtonProps={{ children: 'Annulla' }}
        />
    );
};

export default DeleteSimulationAlert;
